import "../../style/form/pharmacyrequestform.scss";
import { useDispatch, useSelector } from "react-redux";
import { productorder } from "../../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import {
  pharmacyrequest,
  pharmacyrequestput,
  generatereportpharmacy,
} from "../../../text/apidata";
import axios from "axios";
import "rsuite/dist/rsuite.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import BasicTable from "../../maincomponent/reacttable/table";
import noimage1 from "../../../assets/images/noimage.png";
import noimage from "../../../assets/images/noimage.png";
var dataobj = {};

function PharmacyRequestForm(props) {
  const productstate = useSelector((state) => state.counter.productorder);
  const productid = useSelector((state) => state.counter.productorderid);
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const tablepage = useNavigate();
  const dispatch = useDispatch();
  const [data, setdata] = useState([]);
  const [alert, setalert] = useState(false);

  const [postdata, setpostdata] = useState(dataobj);

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [totalamount, settotalamount] = useState(0);
  const [recall, setrecall] = useState(false);
  const [otherdetails, setotherdetails] = useState({
    discount_percent: 0,
    delivery_charge: 0,
    flat_discount: 0,
    notes: "",
  });
  console.log(postdata, "postdata");
  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          dispatch(productorder(""));
          setalert(false);
          tablepage("/PharmacyRequest");
        }
      });
    } else {
      dispatch(productorder(""));
      setalert(false);
      setdata([]);
      tablepage("/PharmacyRequest");
    }
  };

  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: pharmacyrequest + productid + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data.data);
        setdata(res.data.data);
        const listOfObjects = [res.data.data];
        settableheaderdata(listOfObjects);
        setotherdetails({
          discount_percent: res.data.data.discount_percent,
          delivery_charge: res.data.data.delivery_charge,
          notes: res.data.data.notes,
          flat_discount: res.data.data.flat_discount,
        });
        let totalAmount = 0;

        res.data.data.cart_products.forEach((element) => {
          const totalAmountValue = parseFloat(element.totalamount);
          if (!isNaN(totalAmountValue)) {
            totalAmount += totalAmountValue;
          }
          if (element.new_medicine == true) {
            setpostdata((prev) => {
              return {
                ...prev,
                [element.id]: {
                  single_price: element.single_price,
                  totalamount: element.single_price * element.quantity,
                  id: element.id,
                  available: element.available,
                  quantity: element.quantity,
                },
              };
            });
          } else {
            setpostdata((prev) => {
              return {
                ...prev,
                [element.id]: {
                  single_price: element.single_price,
                  totalamount: element.single_price * element.quantity,
                  id: element.id,
                  available: element.available,
                  quantity: element.quantity,
                },
              };
            });
          }
        });
        settotalamount(totalAmount);

        props.loaderchange("false");
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
      });
  }, [recall]);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const newusercreate = () => {
    const listOfObjects = Object.keys(postdata).map((key) => {
      return {
        id: key,
        ...postdata[key],
      };
    });
    console.log(listOfObjects, "test", postdata);
    const data = {
      editproducts: listOfObjects,
      discount_percent: otherdetails.discount_percent,
      delivery_charge: otherdetails.delivery_charge,
      notes: otherdetails.notes,
      flat_discount: otherdetails.flat_discount,
    };
    axios({
      method: "put",
      url: pharmacyrequestput + productid + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      data: data,
    })
      .then((res) => {
        console.log(res);
        Swal.fire({
          icon: "success",
          title: "Your Data has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
        setrecall(true);
        setalert(false);
      })
      .catch((err) => {});
  };

  const validation = (e, ele) => {
    setalert(true);
    if (e.target.value < 0) {
      e.target.value = 0; // Set the value to the minimum (0)
    }
    if (e.target.name == "single_price") {
      setpostdata((prev) => {
        return {
          ...prev,
          [ele.id]: {
            [e.target.name]: e.target.value,
            totalamount: ele.quantity * e.target.value,
            id: ele.id,
            available: postdata[ele.id].available,
            quantity: postdata[ele.id].quantity,
          },
        };
      });
    } else if (e.target.name == "available") {
      setpostdata((prev) => {
        return {
          ...prev,
          [ele.id]: {
            single_price: postdata[ele.id].single_price,
            totalamount: postdata[ele.id].totalamount,
            id: ele.id,
            available: e.target.checked,
            quantity: postdata[ele.id].quantity,
          },
        };
      });
    } else if (e.target.name == "quantity") {
      setpostdata((prev) => {
        console.log(postdata[ele.id].single_price, e.target.value, "value");
        return {
          ...prev,
          [ele.id]: {
            single_price: postdata[ele.id].single_price,
            totalamount: postdata[ele.id].single_price * e.target.value,
            id: ele.id,
            available: postdata[ele.id].available,
            quantity: e.target.value,
          },
        };
      });
    } else if (e.target.name == "discount_percent") {
      if (e.target.value != "") {
        if (e.target.value > 100) {
          // alert("No numbers above 100");
          setotherdetails({
            ...otherdetails,
            [e.target.name]: 100,
          });
        } else {
          setotherdetails({
            ...otherdetails,
            [e.target.name]: e.target.value,
          });
        }
      } else {
        setotherdetails({
          ...otherdetails,
          [e.target.name]: 0,
        });
      }
    } else if (e.target.name == "delivery_charge") {
      setotherdetails({
        ...otherdetails,
        [e.target.name]: e.target.value,
      });
    } else if (e.target.name == "notes") {
      setotherdetails({
        ...otherdetails,
        [e.target.name]: e.target.value,
      });
    } else if (e.target.name == "flat_discount") {
      setotherdetails({
        ...otherdetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  useEffect(() => {
    const totalamountchange = Object.keys(postdata).reduce((total, item) => {
      const totalAmountValue = parseFloat(postdata[item].totalamount);
      if (!isNaN(totalAmountValue)) {
        return total + totalAmountValue;
      }
      return total;
    }, 0);
    console.log(totalamountchange);
    settotalamount(totalamountchange);
  }, [postdata]);
  const columns = useMemo(
    () => [
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.phone_number}
              >
                {String(row.row.original.phone_number)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Assigned By",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_by}
              >
                {String(row.row.original.assigned_by)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Assigned To",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.assigned_to}
              >
                {String(row.row.original.assigned_to)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Need Prescription",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.need_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.need_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Prescription upload",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.upload_prescription &&
              row.row.original.upload_prescription.length > 0 ? (
                row.row.original.upload_prescription.map((ele) => {
                  {
                    /* console.log(ele,"testajh") */
                  }
                  return (
                    <>
                      <a href={ele ? ele : noimage} target="_blank">
                        <img
                          style={{
                            height: "2.5rem",
                            width: "2.5rem",
                            borderRadius: "50%",
                            margin: "4px",
                          }}
                          src={ele ? ele : noimage1}
                        ></img>
                      </a>
                    </>
                  );
                })
              ) : (
                <>
                  <a href={noimage} target="_blank">
                    <img
                      style={{
                        height: "2.5rem",
                        width: "2.5rem",
                        borderRadius: "50%",
                        margin: "4px",
                      }}
                      src={noimage1}
                    ></img>
                  </a>
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "No Prescription",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.no_prescription == false ? "No" : "Yes"
                }
              >
                {row.row.original.no_prescription == false ? "No" : "Yes"}
              </p>
            </>
          );
        },
      },

      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.status}
              >
                {row.row.original.status}
              </p>
            </>
          );
        },
      },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.total_amount}
              >
                {parseFloat(row.row.original.total_amount).toFixed(2) != "NaN"
                  ? parseFloat(row.row.original.total_amount).toFixed(2)
                  : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ordercreaterazorpay != null ? (
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    row.row.original.ordercreaterazorpay.isPaid == false
                      ? "No"
                      : "Yes"
                  }
                >
                  {row.row.original.ordercreaterazorpay.isPaid == false ? (
                    <p style={{ color: "red", fontWeight: 700 }}>No</p>
                  ) : (
                    <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                  )}
                </p>
              ) : row.row.original.fully_used == false ? (
                <p style={{ color: "red", fontWeight: 700 }}>No</p>
              ) : (
                <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
              )}
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const generatereport = () => {
    Swal.fire({
      title: "Do you want to Generate Request?",
      showCancelButton: true,
      confirmButtonText: "Generate Request",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: generatereportpharmacy + productid + "/",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            console.log(res.data.data);
            Swal.fire("Report Generated", "", "success").then((result) => {
              tablepage("/PharmacyRequest");
            });

            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
          });
      }
    });
  };
  return (
    <>
      <div className={sideactive ? "doctorform-sa" : "doctorform"}>
        <BasicTable
          columns={columns}
          data={tableheaderdata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          // stateid={"1"}
        />

        <div class="card mt-5">
          <div class="card-header">
            <h5 class="card-title" style={{ padding: "6px", margin: 0 }}>
              Product Request Edit
            </h5>

            {recall == true && (
              <button
                className="generate_report"
                onClick={(e) => {
                  generatereport();
                }}
              >
                Generate Request
              </button>
            )}
          </div>
          <div class="card-body">
            <form
              style={{ padding: "0 1.5rem 0rem" }}
              className="formspace"
              onSubmit={handleSubmit}
            >
              {data != [] &&
                data.cart_products &&
                data.cart_products.map((ele) => {
                  if (ele.new_medicine == true) {
                    return (
                      <div class="form-row">
                        <div class="form-group col-md-3 p-1 m-0 ">
                          <label for="validationCustom01" class="form-label">
                            Product Name
                          </label>
                          <input
                            type="text"
                            class="form-control "
                            id="validationCustom01"
                            name="product_name"
                            autoComplete="off"
                            value={ele.medicine_name}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            readOnly
                          ></input>
                        </div>
                        <div class="form-group col-md-2 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Price
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            id="validationCustom01"
                            name="single_price"
                            autoComplete="off"
                            value={postdata[ele.id].single_price}
                            onChange={(e) => {
                              validation(e, ele);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => {
                              document.activeElement.blur();
                            }}
                          ></input>
                        </div>
                        <div class="form-group col-md-3 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Product quantity
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            name="quantity"
                            autoComplete="off"
                            value={postdata[ele.id].quantity}
                            onChange={(e) => {
                              validation(e, ele);
                            }}
                            // onKeyDown={(e) => {
                            //   if (
                            //     e.target.value.length === 0 &&
                            //     e.which === 32
                            //   ) {
                            //     e.preventDefault();
                            //   }
                            // }}
                            // readOnly
                          ></input>
                        </div>
                        <div class="form-group col-md-2 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Total Amount
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            name="totalamount"
                            autoComplete="off"
                            value={
                              postdata[ele.id].totalamount != null
                                ? postdata[ele.id].totalamount.toFixed(2)
                                : "0.00"
                            }
                            // onChange={(e)=>{validation(e,ele)}}

                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            readOnly
                          ></input>
                        </div>
                        <div
                          class="form-group col-md-2 p-1 m-0"
                          style={{ display: "flex", alignItems: "end" }}
                        >
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="available"
                              value={postdata[ele.id].available}
                              onChange={(e) => {
                                setalert(true);
                                validation(e, ele);
                              }}
                              checked={postdata[ele.id].available}
                            ></input>
                            <label class="form-check-label" for="invalidCheck">
                              Available
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div class="form-row">
                        <div class="form-group col-md-3 p-1 m-0 pharmacychange">
                          <label for="validationCustom01" class="form-label">
                            Product Name
                          </label>
                          <input
                            type="text"
                            className={
                              ele.pharma.need_prescription == true
                                ? "form-control changecolpharmacy"
                                : "form-control"
                            }
                            id="validationCustom01"
                            name="product_name"
                            autoComplete="off"
                            value={ele.pharma.product_name}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            readOnly
                          ></input>
                        </div>
                        <div class="form-group col-md-2 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Price
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            id="validationCustom01"
                            name="single_price"
                            autoComplete="off"
                            value={postdata[ele.id].single_price}
                            onChange={(e) => {
                              validation(e, ele);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => {
                              document.activeElement.blur();
                            }}
                          ></input>
                        </div>
                        <div class="form-group col-md-3 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Product quantity
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            name="quantity"
                            autoComplete="off"
                            value={postdata[ele.id].quantity}
                            onChange={(e) => {
                              validation(e, ele);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                            // readOnly
                          ></input>
                        </div>

                        <div class="form-group col-md-2 p-1 m-0">
                          <label for="validationCustom01" class="form-label">
                            Total Amount
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            name="totalamount"
                            autoComplete="off"
                            value={
                              postdata[ele.id].totalamount != null
                                ? postdata[ele.id].totalamount.toFixed(2)
                                : "0.00"
                            }
                            // onChange={(e)=>{validation(e,ele)}}
                            readOnly
                            onKeyDown={(e) => {
                              if (
                                e.target.value.length === 0 &&
                                e.which === 32
                              ) {
                                e.preventDefault();
                              }
                            }}
                          ></input>
                        </div>
                        <div
                          class="form-group col-md-2 p-1 m-0"
                          style={{ display: "flex", alignItems: "end" }}
                        >
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="available"
                              value={postdata[ele.id].available}
                              onChange={(e) => {
                                setalert(true);
                                validation(e, ele);
                              }}
                              id="invalidCheck"
                              checked={postdata[ele.id].available}
                            ></input>
                            <label class="form-check-label" for="invalidCheck">
                              Available
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}

              <div class="form-row">
                <div class="form-group col-md-3 p-1 m-0">
                  <label for="validationCustom01" class="form-label">
                    Discount
                  </label>
                  <div style={{ display: "flex" }}>
                    <span
                      class="input-group-text"
                      id="inputGroupPrepend"
                      style={{ borderRadius: "6px 0px 0px 6px" }}
                    >
                      %
                    </span>

                    <input
                      type="number"
                      class="form-control"
                      id="validationCustomn1"
                      name="discount_percent"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        console.log(e.keyCode);
                        if (
                          !(
                            (e.keyCode > 95 && e.keyCode < 106) ||
                            (e.keyCode > 47 && e.keyCode < 58) ||
                            e.keyCode == 8 ||
                            e.keyCode == 37 ||
                            e.keyCode == 39
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      style={{ borderRadius: " 0px 6px 6px 0px" }}
                      value={otherdetails.discount_percent}
                      onChange={(e) => validation(e)}
                      max="100"
                      required
                      onWheel={(e) => {
                        document.activeElement.blur();
                      }}
                    ></input>
                  </div>{" "}
                </div>
                <div class="form-group col-md-5 p-1 m-0">
                  <label for="validationCustom01" class="form-label">
                    Notes
                  </label>

                  <textarea
                    type="textarea"
                    class="form-control"
                    id="validationCustom01"
                    name="notes"
                    value={otherdetails.notes}
                    onChange={(e) => {
                      validation(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.target.value.length === 0 && e.which === 32) {
                        e.preventDefault();
                      }
                    }}
                    rows="4"
                  ></textarea>
                </div>
                <div class="form-group col-md-4 p-1 m-0">
                  <label for="validationCustom01" class="form-label">
                    Delivery Charge
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    id="validationCustom01"
                    name="delivery_charge"
                    autoComplete="off"
                    value={otherdetails.delivery_charge}
                    onChange={(e) => {
                      validation(e);
                    }}
                    onKeyDown={(e) => {
                      if (e.target.value.length === 0 && e.which === 32) {
                        e.preventDefault();
                      }
                    }}
                  ></input>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3 p-1 m-0">
                  <label for="validationCustom01" class="form-label">
                    Flat discount
                  </label>
                  <div style={{ display: "flex" }}>
                    <span
                      class="input-group-text"
                      id="inputGroupPrepend"
                      style={{ borderRadius: "6px 0px 0px 6px" }}
                    >
                      %
                    </span>

                    <input
                      type="number"
                      class="form-control"
                      id="validationCustomn1"
                      name="flat_discount"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        console.log(e.keyCode);
                        if (
                          !(
                            (e.keyCode > 95 && e.keyCode < 106) ||
                            (e.keyCode > 47 && e.keyCode < 58) ||
                            e.keyCode == 8 ||
                            e.keyCode == 37 ||
                            e.keyCode == 39
                          )
                        ) {
                          e.preventDefault();
                        }
                      }}
                      style={{ borderRadius: " 0px 6px 6px 0px" }}
                      value={otherdetails.flat_discount}
                      onChange={(e) => validation(e)}
                      required
                      onWheel={(e) => {
                        document.activeElement.blur();
                      }}
                    ></input>
                  </div>{" "}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div
                  className="form-row"
                  style={{ justifyContent: "end", width: "51%" }}
                >
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Total Amount
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="validationCustom01"
                      name="delivery_charge"
                      autoComplete="off"
                      value={totalamount.toFixed(2)}
                      readOnly
                    ></input>
                  </div>
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Discount Percent
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        %
                      </span>

                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        name="discount_percent"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8 ||
                              e.keyCode == 37 ||
                              e.keyCode == 39
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        disabled={true}
                        onChange={(e) => {
                          validation(e);
                        }}
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={otherdetails.discount_percent}
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>{" "}
                  </div>
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Discounted Amount
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={(
                          totalamount *
                          (otherdetails.discount_percent / 100)
                        ).toFixed(2)}
                        readOnly
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>{" "}
                  </div>
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Flat Discount
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={otherdetails.flat_discount}
                        readOnly
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>{" "}
                  </div>
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Delivery Charge
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={otherdetails.delivery_charge}
                        readOnly
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>{" "}
                  </div>
                  <div
                    class="form-group col-md-12 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "baseline",
                    }}
                  >
                    <label
                      for="validationCustom01"
                      class="form-label"
                      style={{ width: "250px" }}
                    >
                      Final Amount To Pay
                    </label>
                    <div style={{ display: "flex", width: "100%" }}>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.keyCode > 95 && e.keyCode < 106) ||
                              (e.keyCode > 47 && e.keyCode < 58) ||
                              e.keyCode == 8
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={(
                          totalamount -
                          totalamount *
                            (Number(otherdetails.discount_percent) / 100) +
                          Number(otherdetails.delivery_charge) -
                          Number(otherdetails.flat_discount)
                        ).toFixed(2)}
                        readOnly
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                style={{
                  display: "flex",
                  flexFlow: "row wrap",
                  placeContent: "center space-between",
                  alignItems: "center",
                }}
              >
                <div class="form-group col-md-12 pb-3 pt-4 m-0">
                  <button
                    class="btn btn-primary"
                    type="submit"
                    onClick={(e) => newusercreate(e)}
                    disabled={
                      !alert ||
                      totalamount -
                        totalamount *
                          (Number(otherdetails.discount_percent) / 100) +
                        Number(otherdetails.delivery_charge) -
                        Number(otherdetails.flat_discount).toFixed(2) <=
                        0
                        ? true
                        : false
                    }
                  >
                    Save
                  </button>
                  <button
                    class="btn btn-danger"
                    style={{ float: "right" }}
                    onClick={(e) => cancelnewuser(e)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>{" "}
    </>
  );
}

export default PharmacyRequestForm;
